export const ANALYTICS_ID = 'analytics';
export const ADVERTISING_ID = 'advertising';
export const HELP_MENU_ID = 'help';
export const DESIGN_MENU_ID = 'design';
export const UPGRADE_BANNER_ID = 'upgrade';
export const DOMAIN_BANNER_ID = 'domain';
export const HIDE_SUBMENU = '@WS/nav-submenu/hide';
